var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Live = OCS.Viewer.Live || {};
OCS.Viewer.Live.Sources = OCS.Viewer.Live.Sources || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Classes.AbstractSource = new Class({
    Implements: [Options, Events, new Class(OCS.Viewer.Interfaces.OlObject), new Class(OCS.Viewer.Interfaces.OlEvent), new Class(OCS.Viewer.Interfaces.DataAccessor)],
    class_type: "Source",
    class_name: "AbstractSource",
    source: null,
    ready: false,
    keep_data: false, // Setting for whether or not to keep data
    data_avail: false,
    data_source_timeout: null,
    bound_events: {},
    options: {
        init: {
            auto: false,
            max_val: null,
            min_val: null
        },
        max_val: null,
        min_val: null,
        metadata: {
            dataset: "",
            grid: false,
            source_type: '',
            timestamp_epoch: 0,
            variables: []
        },
        projection: OCS.Viewer.Config.default_projection,
        display_projection: OCS.Viewer.Config.default_display_projection
    },
    data: {},
    initialize: function (ops) {
        this.setOptions(ops);
        this.create();
        this.addEvent('refresh', this.refresh_source.bind(this));
        this.addEvent('changed', this.source_changed.bind(this));
        if(OCS.Settings.debug) {
            OCS.Viewer.Live.Sources[this.get_id()] = this;
        }

    },
    create: function () {
        if (!this.get_ol_object()) {
            this.destroy_source();
        }
        return this.get_ol_object();
        // Create the source - to be overridden by the child classes
    },
    process_data_request: function (data_request) {
        if (this.data && Object.keys(this.data).length) {
            return;
        }
        var data_result;
        var request_ops = this.options.metadata;

        if (request_ops.timestamp_epoch) {
            data_result = data_request.get_data_at_timestamp_epoch(request_ops.timestamp_epoch);
        } else {
            data_result = data_request.get_data();
        }

        this.set_data(this.process_data_array(data_result));
    },
    process_data: function () {
        switch (this.get_datatype()) {
            case "advisories":
                this.process_advisories();
                break;
            case "lightning":
                this.process_lightning();
                break;
            case "netcdf":
                if (this.options.metadata.grid) {
                    this.process_gridded_netcdf();
                } else {
                    this.process_netcdf();
                }
                break;
            case "nids":
                this.process_nids();
                break;
            case "polygons":
                this.process_polygons();
                break;
            case "shapefile":
                this.process_shapefile();
                break;
            case "userdata":
                this.process_userdata();
                break;
            default:
                this.process_default();
                break;
        }
        this.data_source_ready();
    },

    process_data_array: function (data_obj) {
        var j, variable;
        // build the data we are sending on 
        var src_metadata = this.get_metadata();
        var out_data = false;
        if (data_obj.contains_all_data_variables(src_metadata.variables)) {
            out_data = OCS.Functions.define_data_obj({entry: {json: {dataset: src_metadata.dataset, info: {variables: src_metadata.variables, timestamp: src_metadata.timestamp_epoch, grid: src_metadata.grid}, payload: true}}});
            switch (this.get_datatype()) {
                case 'nids':
                    return data_obj.json();
                default:
                    for (j = 0; j < src_metadata.variables.length; j++) {
                        variable = src_metadata.variables[j];
                        out_data.add_data_variable(data_obj.get_data_variable(variable), variable);
                    }
                    break;
            }
            out_data = out_data.json();
        }
        return out_data;
    },
    process_advisories: function () {

    },
    process_default: function () {

    },
    process_lightning: function () {

    },
    process_gridded_netcdf: function () {
        var data = this.get_data();
        if (this.get_auto() && this.options.metadata.variables.length === 1 && data.variables && data.variables[this.options.metadata.variables[0].parm]) {
            var minmax = OCS.Viewer.Functions.get_utilities().get_2dmin_array_minmax(data.variables[this.options.metadata.variables[0].parm].data);
            this.options.min_val = minmax.min;
            this.options.max_val = minmax.max;
        } else {
            this.options.min_val = parseFloat(this.options.init.min_val);
            this.options.max_val = parseFloat(this.options.init.max_val);
        }
    },
    process_netcdf: function () {

    },
    process_nids: function () {

    },
    process_polygons: function () {

    },
    process_shapefile: function () {

    },
    rangeBetweenPoints: function (inPoint1, inPoint2) {
        var wgs84Sphere = new ol.Sphere(6378137);
        return wgs84Sphere.haversineDistance(ol.proj.transform(inPoint1, OCS.Viewer.Config.default_projection, OCS.Viewer.Config.default_display_projection), ol.proj.transform(inPoint2, OCS.Viewer.Config.default_projection, OCS.Viewer.Config.default_display_projection));
    },
    refresh_source: function () {
        var source = this.get_source();
        if (source) {
            source.refresh();
            this.fireEvent('refreshed', this, 1);
        }
    },
    source_changed: function () {
        var source = this.get_source();
        if (source) {
            source.changed();
        }
    },

    get_auto: function () {
        return this.options.init.auto;
    },
    set_data: function (data_obj) {
        if (data_obj) {
            this.data_avail = false;
            this.data = data_obj;
            this.set_data_avail();
        }
    },
    get_data_obj: function () {
        return this.data;
    },
    get_data: function () {
        return this.data.data();
    },
    get_json_data: function () {
        return this.data.json();
    },
    get_metadata: function () {
        return this.options.metadata;
    },
    get_variables: function () {
        return this.options.metadata.variables;
    },
    set_data_avail: function () {
        if (!this.data_avail) {
            this.data_avail = true;
            this.process_data();
        }
    },
    get_gridded: function () {
        return this.options.metadata.gridded;
    },
    get_dataset: function () {
        return this.options.metadata.dataset;
    },
    get_dataset_obj: function () {
        var name = this.get_dataset();
        if (OCS.Datasets[name]) {
            return OCS.Datasets[name];
        } else {
            return new OCS.Classes.Dataset();
        }
    },
    get_datatype: function () {
        return this.get_dataset_obj().get_datatype();
    },
    get_max_val: function () {
        return this.options.max_val;
    },
    get_min_val: function () {
        return this.options.min_val;
    },
    get_init_max_val: function () {
        return this.options.init.max_val;
    },
    get_init_min_val: function () {
        return this.options.init.min_val;
    },
    get_properties: function () {
        var source = this.get_ol_object();
        return source.getKeys();
    },
    get_revision: function () {
        var source = this.get_ol_object();
        return source.getRevision();
    },
    get_source_ops: function (options) {
        return {}; // Create and return the source options - to be overridden by the child classes
    },
    get_source: function () {
        var source = this.get_ol_object();
        if (!source) {
            return this.create();
        }
        return source;
    },
    get_source_type: function () {
        return this.options.metadata.source_type;
    },
    get_timestamp_epoch: function () {
        return this.options.metadata.timestamp_epoch;
    },
    set_timestamp_epoch: function (ts) {
        this.options.metadata.timestamp_epoch = ts * 1;
    },
    data_source_ready: function () {
        if (!this.ready) {
            this.ready = true;
            if (this.data_source_timeout) {
                clearTimeout(this.data_source_timeout);
                this.data_source_timeout = null;
            }
            this.data_source_timeout = setTimeout(function () {
                this.refresh_source();
                this.fireEvent('ready', this);
            }.bind(this), 0);
        }
    },
    destroy_source: function () {
        this.remove_all_events();
    },
    destroy: function () {
        if(OCS.Settings.debug) {
            delete OCS.Viewer.Live.Sources[this.get_id()];
        }
        this.options = {
            init: {
                auto: false,
                max_val: null,
                min_val: null
            },
            max_val: null,
            min_val: null,
            metadata: {
                dataset: "",
                grid: false,
                source_type: '',
                timestamp_epoch: 0,
                variables: []
            },
            projection: OCS.Viewer.Config.default_projection,
            display_projection: OCS.Viewer.Config.default_display_projection
        };
        if (this.data_source_timeout) {
            clearTimeout(this.data_source_timeout);
            this.data_source_timeout = null;
        }
        this.data = {};
        this.ready = false;
        this.removeEvents();
        this.destroy_source();
        this.$events = {};
        this.set_ol_object(null);
    }
});



